import palette from '../palette'

export default {
  styleOverrides: {
    root: {
      boxShadow: 'none',
      fontWeight: 400,
      fontFamily: 'Inter, sans-serif',
      '&:hover': {
        boxShadow: 'none'
      },
      '&.mui-jss-MuiButton-containedSizeMedium': {
        height: '35px',
      },
      '&.mui-jss-MuiButton-outlinedSizeMedium': {
        height: '35px',
      },
    },
    outlined: {
      backgroundColor: palette.white,
    },
  }
}
